<template>
  <div class="corporate content">
    <img src="../../assets/qiye2.jpg" @load="bgImgLoadEnd()" class="bg_img" />
    <div class="corporate_content" :style="{ height: bg_img_height + 'px' }">
      <div class="inner">
        <div class="content_title">
          <div class="flex title1">
            <div class="flex-item left">
              <span class="line_corporate"></span>
            </div>
            <div class="text_corporate">
              <span>企业</span>
              <span class="red">文化</span>
            </div>
            <div class="flex-item right">
              <span class="line_corporate"></span>
            </div>
          </div>
          <div class="title2_corporate">CORPORATE</div>
        </div>
        <div class="flex" :style="{ marginTop: (bg_img_height - 60 - 270) / 2 + 'px' }">
          <div class="flex-item">
            <transition name="bounce">
              <div v-if="show" class="corporate_item">
                <div class="corporate_title">愿景</div>
                <div class="corporate_desc">
                  成为全球领先的自动化和智慧城市解决方案提供商，推动社会向更加智能化、可持续化的方向发展。
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 60px"></div>
          <div class="flex-item">
            <transition name="bounce">
              <div v-if="show" class="corporate_item">
                <div class="corporate_title">期望</div>
                <div class="corporate_desc">
                  通过技术创新和优质服务，成为自动化和智慧城市领域的领导者
                </div>
              </div>
            </transition>
          </div>
          <div style="width: 60px"></div>
          <div class="flex-item">
            <transition name="bounce">
              <div v-if="show" class="corporate_item">
                <div class="corporate_title">使命</div>
                <div class="corporate_desc">
                  致力于推动自动化技术的发展，为客户提供高效、智能的解决方案，助力企业在数字化转型中实现更高的生产效率和更低的运营成本。
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg_img_height: 350,
      show: false,
    };
  },
  mounted() {
    this.bg_img_height = document.querySelector(".bg_img").offsetHeight;
  },
  methods: {
    bgImgLoadEnd: function () {
      this.bg_img_height = document.querySelector(".bg_img").offsetHeight;
      this.show = true;
    },
  },
};
</script>

<style>
.corporate {
  position: relative;
  padding: 0px;
}
.content .bg_img {
  width: 100%;
  height: 900px;
}
.corporate_content {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  padding-top: 50px;
  /* padding-bottom: 50px; */
  /* background: url(../../assets/qiye2.jpg);
  background-size: 100% 100%; */
}
.content_title .text_corporate {
  width: 150px;
  line-height: 40px;
  text-align: center;
  color: #fff;
}
.content_title .line_corporate {
  width: 100px;
  background: #fff;
  display: inline-block;
  height: 2px;
}
.content_title .title2_corporate {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  text-align: center;
  color: #fff;
}
.corporate_item {
  width: 100%;
  height: 150px;
  background: rgb(255, 255, 255, 0.7);
  border-radius: 5px;
  padding: 10px;
}
.corporate_item .corporate_title {
  height: 60px;
  line-height: 60px;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}
.corporate_item .corporate_desc {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #666;
  text-align: center;
}
.bounce-enter-active {
  animation: bounce-in 1s;
}
.bounce-leave-active {
  animation: bounce-in 1s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  /* 50% {
    transform: scale(0.5);
  } */
  100% {
    transform: scale(1);
  }
}
</style>
